import { useI18n } from "../i18n";
import { Reveal } from "./Reveal";

const PORTRAIT = "/gilles.jpg";
const YEARS = ["1987–1993", "1990", "2000", "2005", "2018", "2027"];

export const Biography = () => {
  const { t } = useI18n();
  const milestones = YEARS.map((year, i) => ({ year, text: t(`bio.m${i + 1}`) }));

  return (
    <section id="biographie" className="py-24 sm:py-32 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-xl">
            <img src={PORTRAIT} alt="Gilles de Buretel de Chassey" className="w-full h-full object-cover" />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#0B1121] to-transparent p-6">
              <p className="font-mono-accent text-xs uppercase tracking-widest text-white/80">
                Gilles de Buretel de Chassey
              </p>
              <p className="font-display font-bold text-white text-lg">{t("bio.photoSub")}</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#E1000F] mb-4">
            {t("bio.eyebrow")}
          </p>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl text-[#0B1121] leading-[0.95]">
            {t("bio.title")}
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">{t("bio.p1")}</p>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">{t("bio.p2")}</p>

          <Reveal className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-200 rounded-2xl overflow-hidden border border-slate-200">
            {milestones.map((m, i) => (
              <div key={i} data-testid={`milestone-${i}`} className="bg-white p-6">
                <div className="font-mono-accent text-2xl font-semibold text-[#001489]">{m.year}</div>
                <p className="mt-1 text-slate-600">{m.text}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
